/**
 * Late fee policy — BHCS 2026–2027 Enrollment & Billing Guide, Section 3.
 *
 * Invoices are sent on the 20th for the following month and are due by the 1st of
 * the service month, with a grace period through the 5th. After that:
 *
 *   Paid by the 5th   → no fee (grace period)
 *   Paid 6th – 9th    → 10% of the outstanding balance
 *   Paid 10th or later → 20% of the outstanding balance
 *
 * The fee is a percentage of the **outstanding balance** (invoice total minus
 * amount already paid), not of tuition alone. Any late fee already on the invoice
 * is excluded from the base so escalating from 10% to 20% never compounds.
 *
 * Admins apply these manually from Admin → Finances (Invoices / Debt). The two
 * tiers are stored as the line item descriptions `First late fee` and
 * `Second time late fee` — those exact strings are load-bearing filters in the
 * CLI/MCP skills and the agent knowledge base, so do not rename them here.
 */
export const LATE_FEE = {
  /** 10% — payment received 6th–9th. Line item: "First late fee". */
  firstRate: 0.10,
  /** 20% — payment received on the 10th or later. Line item: "Second time late fee". */
  secondRate: 0.20,
  /** Grace period: no fee if the invoice is paid on or before this day of the month. */
  graceThroughDayOfMonth: 5,
} as const;

/** Public link to the Enrollment & Billing Guide (late fee schedule in Section 3). */
export const BILLING_POLICY_URL =
  'https://drive.google.com/file/d/1t6MT1AYoRWYORUboL9Wzfhge9XSoM1-E/view';

/** `0.1` → `"10%"`, for button titles and email copy. */
export function formatLateFeeRate(rate: number): string {
  return `${Math.round(rate * 1000) / 10}%`;
}
